import { components } from './components';
import CustomElementWrapper from './custom-element-wrapper';

components.map(([module]) => customElements.define(`ts-${module}`, class extends CustomElementWrapper {}));
